module.exports = __webpack_public_path__ + "img/blog_21.6eb498e5.jpeg";